var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCost") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.16,0.14 C9.56002047,0.144952696 12.3150473,2.89997953 12.32,6.3 C12.32,9.70207406 9.56207406,12.46 6.16,12.46 C2.75792594,12.46 -1.23262396e-15,9.70207406 1.97215226e-31,6.3 C1.03294589e-15,2.89792594 2.75792594,0.14 6.16,0.14 Z M6.69688422,5.6894902 L6.69688422,3.93262745 C7.02059036,4.02490869 7.32307521,4.17389969 7.58858968,4.37184314 C7.67921393,4.43701453 7.79058619,4.47109052 7.90440202,4.46847059 C8.0451852,4.47201134 8.18156568,4.42189208 8.2828811,4.3293811 C8.38419653,4.23687013 8.4419442,4.10973124 8.44314074,3.97654902 C8.43889781,3.79728449 8.33935541,3.63212979 8.17841568,3.53733334 C7.75007331,3.24028104 7.25358103,3.04313555 6.72939431,2.96196079 L6.72939431,2.83898039 C6.72939431,2.58549252 6.512105,2.38 6.24406504,2.38 C5.97602509,2.38 5.75873577,2.58549252 5.75873577,2.83898039 L5.75873577,2.93560784 C4.62552675,3.05419608 3.84528448,3.75694118 3.84528448,4.69247059 C3.84528448,5.62800001 4.40724469,6.19019609 5.80053446,6.51960785 L5.80053446,8.32478433 C5.31531303,8.22453621 4.86670881,8.00483575 4.50013067,7.68792158 C4.34251648,7.56920853 4.12731274,7.54539309 3.94497556,7.62648554 C3.76263837,7.70757799 3.64477834,7.87951986 3.64093531,8.07003923 C3.62994955,8.24408371 3.71633818,8.4108154 3.86850597,8.50925492 C4.41479732,8.93178447 5.07362606,9.20380355 5.77266867,9.295451 L5.77266867,9.76101963 C5.77266868,10.0145075 5.98995799,10.22 6.25799794,10.22 C6.52603789,10.22 6.7433272,10.0145075 6.74332721,9.76101963 L6.74332721,9.32180394 C7.90904632,9.19003923 8.68,8.48290198 8.68,7.52980393 C8.68,6.57670589 8.0715968,6.03207844 6.71546142,5.71584315 L6.69688422,5.6894902 Z M5.78660156,5.4962353 C5.00171499,5.25905883 4.9366948,4.9867451 4.9366948,4.67929412 C4.9366948,4.27521569 5.26644005,3.98533334 5.78660156,3.90627451 L5.78660156,5.4962353 Z M6.71546142,8.38627452 L6.71546142,6.73043138 C7.52356949,6.96760785 7.59323397,7.24431374 7.59323397,7.54737256 C7.59323397,7.98658825 7.26348873,8.2764706 6.71546142,8.35992158 L6.71546142,8.38627452 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version3-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-Details-Popup",
    transform: "translate(-439.000000, -573.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(420.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(19.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/Users-Copy-4",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Location-Copy",
    transform: "translate(0.840000, 0.700000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCost",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCost);
export default __webpack_public_path__ + "static/media/icCost.a87780dca21211114cf029021aa8c542.svg";
export { ForwardRef as ReactComponent };